import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import { Visit } from "../../../models/Visit";
import { baseQuery, reducerPath } from "../../api_client/arps_api";
import EMAIL_API from "../../api_client/email_api";

const tagTypes = ["Revenue"];

export type RevenueAPIEndpointBuilder = EndpointBuilder<
  typeof baseQuery,
  typeof tagTypes[number],
  typeof reducerPath
>;

const revenueModelsEndpoints = EMAIL_API.injectEndpoints({
  endpoints: (builder: RevenueAPIEndpointBuilder) => ({
    /*
    |---------------------------------------------------------------------
    |                          Emails Queries & Mutations
    |---------------------------------------------------------------------
    */

    sendEmail: builder.mutation<any, void>({
      query: (payload: any) => ({
        url: "/mail",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Email"],
    }),

    sendResetEmail: builder.mutation<any, void>({
      query: (payload: any) => ({
        url: "/mail/password/reset",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Email"],
    }),
  }),
  overrideExisting: false,
});

export const { useSendEmailMutation, useSendResetEmailMutation } =
  revenueModelsEndpoints;
